import { api, qs } from './client.js';

/**
 * 상품 랭킹 순위 — 원본 xadmin/marketing/product/list.php.
 * 서버는 modules/productRank. 쿼리스트링 키는 원본과 같다.
 */
export type ProductRankViewType = 'month' | 'week';
export type ProductRankSortField = 'total' | 'totalorder';
export type ProductRankSortDir = 'ASC' | 'DESC';

export interface ProductRankParams {
  view_type: ProductRankViewType;
  /** 'YYYY-MM'(월별) / 'YYYY-MM-DD'(주차별) / '' */
  search_date: string;
  product_code: string;
  sort_field: ProductRankSortField;
  sort_dir: ProductRankSortDir;
  page: number;
}

export interface ProductRankRow {
  periodKey: number;
  /** '2026-10월' / '2026년 10월 3주차' */
  period: string;
  product: string;
  gname: string | null;
  p: number;
  m: number;
  total: number;
  porder: number;
  morder: number;
  totalorder: number;
}

export interface ProductRankPage {
  /** 서버가 실제로 적용한 조건 (형식이 틀린 기준일자는 빠져 있다). */
  filters: {
    viewType: ProductRankViewType;
    searchDate: string;
    productCode: string;
    sortField: ProductRankSortField;
    sortDir: ProductRankSortDir;
    page: number;
  };
  items: ProductRankRow[];
  total: number;
  totalPages: number;
  perPage: number;
}

export const productRankApi = {
  list: (p: ProductRankParams) => api.get<ProductRankPage>(`/reports/product-rank${qs({ ...p })}`),
  /** 원본 export_csv.php - 쪽 나눔 없이 전부. */
  csvUrl: ({ page: _page, ...p }: ProductRankParams) => `/api/reports/product-rank/csv${qs({ ...p })}`,
};
